$(document).ready(function(){
   $('.slider-hp ul.product-grid').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
     infinite: false,
    dots:false,
     responsive: [{
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                     
                    }
                },
               {
                    breakpoint: 577,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
   });
  $('.slider_main').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  vertical: true,
   verticalSwiping: true,
    dots:false,
   infinite:false,
  focusOnSelect: true,
 
  asNavFor: '.slider_small',
   responsive: [
    {
      breakpoint: 750,
      settings: {
        vertical: false,
  verticalSwiping: false,
       
      }
    }
     ]
  
});
  var lilen=$('ul.slider_main li').length;
  if(lilen > 6){
    var lilen = 6;
  }
  else{
     var lilen=$('ul.slider_main li').length - 1;
  }
  
$('.slider_small').slick({
   slidesToShow: lilen,
  slidesToScroll: 1,
  draggable:true,
  focusOnSelect: true,
  vertical: true,
  verticalSwiping: true,
  arrows: true,
  
infinite:false,
  
  asNavFor: '.slider_main',
  
  responsive: [
    {
      breakpoint: 1366,
      settings: {
        slidesToShow: 3
      }
    },
    
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        vertical: false,
  verticalSwiping: false
       
      }
    },
    ]
});  
  
             $(document).on("click",".toggle-question-desc",function() {
    $(this).next('.toggle-content-desc').slideToggle();
      $(this).find("svg").toggleClass("svgtoggleclass-desc");
    });
  
    var div = document.getElementById('bookingLabel');
    div.innerHTML += 'Additional Notes:';
});